"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetCompareVehicleIds = exports.removeVehicleIdFromCompare = exports.addVehicleIdToCompare = exports.DELETE_COMPARE_VEHICLE_IDS = exports.REMOVE_VEHICLE_ID_FROM_COMPARE = exports.ADD_VEHICLE_ID_TO_COMPARE = exports.COMPARED_VEHICLE_IDS = void 0;
exports.COMPARED_VEHICLE_IDS = '[compared Vehicle Ids]';
exports.ADD_VEHICLE_ID_TO_COMPARE = `${exports.COMPARED_VEHICLE_IDS} ADD`;
exports.REMOVE_VEHICLE_ID_FROM_COMPARE = `${exports.COMPARED_VEHICLE_IDS} REMOVE`;
exports.DELETE_COMPARE_VEHICLE_IDS = `${exports.COMPARED_VEHICLE_IDS} DELETE`;
const addVehicleIdToCompare = ({ vehicleId }) => ({
    type: exports.ADD_VEHICLE_ID_TO_COMPARE,
    payload: vehicleId,
    meta: { feature: exports.COMPARED_VEHICLE_IDS },
});
exports.addVehicleIdToCompare = addVehicleIdToCompare;
const removeVehicleIdFromCompare = ({ vehicleId }) => ({
    type: exports.REMOVE_VEHICLE_ID_FROM_COMPARE,
    payload: vehicleId,
    meta: { feature: exports.COMPARED_VEHICLE_IDS },
});
exports.removeVehicleIdFromCompare = removeVehicleIdFromCompare;
const resetCompareVehicleIds = () => ({
    type: exports.DELETE_COMPARE_VEHICLE_IDS,
    payload: [],
    meta: { feature: exports.COMPARED_VEHICLE_IDS },
});
exports.resetCompareVehicleIds = resetCompareVehicleIds;
//# sourceMappingURL=comparedVehicleIds.js.map